import { MessageData } from './message-data';

export class Message {
    user: string;
    type: string;
    data: MessageData;
    timestamp: string;
}


// WEBPACK FOOTER //
// ./src/app/core/models/message.ts